import { TimelineStudyRecord } from "./useFetchStudentDailyStudyRecords";

// サマリータブの生徒単位で表示する 1 タイムラインエントリ。
// AI 質問統合表示の凍結（005-freeze-ai-question-timeline）に伴い、学習記録単独型に縮約している。
// 凍結解除時は AI 質問側枝を union として追加する（proposal「復帰時」の記述を参照）。
export type MergedTimelineEntry = {
  type: "studyRecord";
  time: string;
  studyRecord: TimelineStudyRecord;
};

// 学習記録を時刻の昇順に並べる。同時刻の順序は入力順を保つ（Array.prototype.sort は安定ソート）。
export const mergeTimelineEntries = (
  studyRecords: TimelineStudyRecord[],
): MergedTimelineEntry[] =>
  studyRecords
    .map<MergedTimelineEntry>((studyRecord) => ({
      type: "studyRecord" as const,
      time: studyRecord.recordedAt,
      studyRecord,
    }))
    .sort((a, b) => new Date(a.time).getTime() - new Date(b.time).getTime());
